// extracted by css-extract-rspack-plugin
export default {"pureLink":"header-fragment__PureLink_pureLink__G0LVq"};